import React, { useState, useEffect } from "react";
import ListsControl from "./tarjetas/Producto/components/ListsControl/ListsControl";

const DetalleProducto = () => {
  const [producto, setproducto] = useState({});

  useEffect(() => {
    setproducto({
      id: document.getElementById("idProducto")
        ? parseInt(document.getElementById("idProducto").innerHTML)
        : 0,
    });
  }, []);

  return <ListsControl producto={producto} contexto={"detalle-de-producto"} />;
};

export default DetalleProducto;
